import {NewsArticle} from '../type'

import {Link} from '@/src/shared/ui/link'

import {NewsPreview} from './preview'
import * as UI from './tile.styled'

export interface IProps {
  article: NewsArticle
  href: string
  className?: string
  showTitle?: boolean
  datePlacement?: 'left' | 'right'
}

export const NewsTile = ({
  article,
  href,
  className,
  showTitle,
  datePlacement = 'right',
}: IProps) => {
  return (
    <UI.Wrapper className={className}>
      <UI.Link as={Link} href={href} asChild>
        <NewsPreview article={article} showTitle={showTitle} datePlacement={datePlacement} />
      </UI.Link>
    </UI.Wrapper>
  )
}
